module.exports = __webpack_public_path__ + "static/media/04_Einzelteile_Bild_HSR.e70385e8.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle05/04_Einzelteile_Bild_HSR.jpg
 ** module id = 138
 ** module chunks = 0
 **/